import React from 'react';
import { Link } from "react-router-dom";
import { Tooltip } from 'antd';
import { exportToPDF, exportToExcel } from '../utils/exportUtils3';
import ImageWithBasePath from '../../core/img/imagewithbasebath';
const TooltipIcons = ({ excelOptions, pdfOptions }) => {
  // Define your export options

  const handleExcelExport = (e) => {
    e.preventDefault();
    exportToExcel(excelOptions);
  };

  const handlePdfExport = (e) => {
    e.preventDefault();
    exportToPDF(pdfOptions);
  };

  return (
    <>
      <li>
        <Tooltip title="Export to PDF">
          <Link 
            to="#" 
            onClick={handlePdfExport}
            style={{ cursor: 'pointer' }}
          >
            <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="PDF Export" />
          </Link>
        </Tooltip>
      </li>
      <li>
        <Tooltip title="Export to Excel">
          <Link
            to="#"
            onClick={handleExcelExport}
            style={{ cursor: 'pointer' }}
          >
            <ImageWithBasePath src="assets/img/icons/excel.svg" alt="Excel Export" />
          </Link>
        </Tooltip>
      </li>
    </>
  );
};

export default TooltipIcons;